/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const propertyNegotiationTypeEnum = {
    "BUYER": "BUYER",
    "SELLER": "SELLER"
} as const;

export type PropertyNegotiationTypeEnum = (typeof propertyNegotiationTypeEnum)[keyof typeof propertyNegotiationTypeEnum];

/**
 * @description Type de négociation :\n- BUYER : Acquéreur\n- SELLER : Vendeur\n
 * @default BUYER
*/
export type PropertyNegotiationType = PropertyNegotiationTypeEnum;